export default __webpack_public_path__ + "static/media/export.4b378fa7.svg";